import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'calculated-fields',
  templateUrl: './calculated-fields.component.html',
  styleUrls: ['./calculated-fields.component.scss']
})
export class CalculatedFieldsComponent implements OnInit, OnChanges {
  /*
   * For an explanation on how this should work you can view the
   * ticket description TT-685.
   */
  @Input() a = 0;
  @Input() b = 0;
  @Input() c = 0;
  @Input() d = 0;
  fields: CalculatedField[] = [];
  fieldGenerator: CalculatedFieldGenerator;

  constructor() { }

  ngOnInit() {
    this.loadFields();
  }

  loadFields() {
    this.fieldGenerator = new CalculatedFieldGenerator(this.a, this.b, this.c, this.d);
    this.fields = this.fieldGenerator.getFields();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.loadFields();
  }
}

export interface CalculatedField {
  Name: string;
  Reading: number;
}

export class CalculatedFieldGenerator {
  private fields: CalculatedField[] = [];
  constructor(
    private a: number,
    private b: number,
    private c: number,
    private d: number) {
  }

  getFields(): CalculatedField[] {
    this.generateFields();
    return this.fields;
  }

  private generateFields() {
    // Inboard Axial Gap = A + B
    const inboardAxialGap: CalculatedField = {
      Name: 'Inboard Axial Gap',
      Reading: this.a + this.b
    };

    // Outboard Axial Gap = C + D
    const outboardAxialGap: CalculatedField = {
      Name: 'Outboard Axial Gap',
      Reading: this.c + this.d
    };

    // Outboard Axial Gap = C + D
    const totalAxialGap: CalculatedField = {
      Name: 'Total Axial Gap',
      Reading: this.a + this.b + this.c + this.d
    };

    this.fields.push(inboardAxialGap);
    this.fields.push(outboardAxialGap);
    this.fields.push(totalAxialGap);
  }
}
